var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71721 3.71713C7.87342 3.56092 8.12669 3.56092 8.2829 3.71713L11.6162 7.05047C11.7724 7.20668 11.7724 7.45994 11.6162 7.61615C11.46 7.77236 11.2068 7.77236 11.0505 7.61615L8.00006 4.56566L4.94957 7.61615C4.79336 7.77236 4.54009 7.77236 4.38388 7.61615C4.22767 7.45994 4.22767 7.20668 4.38388 7.05047L7.71721 3.71713ZM8.00006 8.56566L4.94957 11.6162C4.79336 11.7724 4.54009 11.7724 4.38388 11.6162C4.22767 11.4599 4.22767 11.2067 4.38388 11.0505L7.71721 7.71713C7.87342 7.56092 8.12669 7.56092 8.2829 7.71713L11.6162 11.0505C11.7724 11.2067 11.7724 11.4599 11.6162 11.6162C11.46 11.7724 11.2068 11.7724 11.0505 11.6162L8.00006 8.56566Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsUp);
export default __webpack_public_path__ + "static/media/chevrons-up.50657bb1cd997013a210f4a196c8f56e.svg";
export { ForwardRef as ReactComponent };